<template lang="pug">
    .play-box
        template(v-if='gameStarted')
            template
                game-header(
                    :time='getTime'
                    @soundStateChanged ="headerKey = !headerKey"
                    :key="headerKey"
                    :slug='type',
                    :game-type='parameters && parameters.courseType',
                    :is-homework="!!exerciseId"
                )
                .play-box__game(v-if='gameStarted && !gameFinished || showUnselectedGameItems')
                    .play-box__example
                        .play-box__header(:class="{'mobile-version': isMobile}")
                            .play-box__task
                                .play-box__title
                                    span
                                        | {{ $i18n.t('trainer.trainer_game_wordField_findElementsAndColorIt') }}
                                .play-box__subtitle
                                    div.play-box__word(v-for="(gameItem, index) in neededGameItems")
                                        img(
                                            :src="`/imgs/games/corrective-samples/${neededPencils[index]}.jpg`"
                                            :style="{width: `${widthForImages}px`, height: `${heightForImages}`, marginRight: '10px'}"
                                            loading="lazy"
                                            )
                                        span(
                                            v-if="!isImages"
                                            :style="{marginRight: '10px'}"
                                            ) {{ gameItem.value }}
                                        img(
                                            v-else
                                            :src="gameItem.value | apiFile"
                                            :style="gameItemsStyle"
                                            )
                            .play-box__scaling-bar-block
                                scaling-bar(
                                    @setFontSize="setFontSize"
                                    :is-game-tuned="true"
                                    :font-size="fontSize"
                                    :element-name="'play-box__field'"
                                    :is-images="isImages"
                                    :key="clientWidth"
                                )
                                template
                                    .play-box__buttons.play-box__buttons--game(
                                            v-if="!showUnselectedGameItems"
                                        )
                                        cs-button.play-box__button(
                                            :disabled='!amountOfSelectedGameItems',
                                            @click='processReply'
                                        )
                                            | {{ $i18n.t('trainer.trainer_gamePlayBox_reply') }}
                                    .play-box__buttons.play-box__buttons--game(
                                        v-if='showUnselectedGameItems'
                                    )
                                        cs-button.play-box__button(
                                            @click='showUnselectedGameItems = false'
                                        )
                                            | {{ $i18n.t('olympiads.olympiads_processStage_further') }}
                        template
                            .play-box__container
                                .play-box__field(
                                    :style="{ maxHeight: heightForPlayBox, height: 'min-content'}"
                                )
                                    template(v-if="isImages")
                                        .play-box__words-row(v-for='(line) in displayedLines')
                                            img.play-box__word(
                                                v-for='(gameItem) in line',
                                                :src="gameItem.value | apiFile"
                                                :class="wordClass(gameItem)",
                                                @click='selectWord(gameItem)'
                                                :style="gameItemsStyle"
                                            )
                                    template(v-else)
                                        .play-box__words-row(v-for='(line) in displayedLines')
                                            .play-box__word(
                                                v-for='(gameItem) in line',
                                                :class="wordClass(gameItem)",
                                                @click='selectWord(gameItem)'
                                                :style="gameItemsStyle"
                                            )
                                                | {{ gameItem.value }}
                                .play-box__palette(
                                    v-if="neededColors"
                                )
                                        .palette-item(
                                            v-for="neededColor in neededColors"
                                            :style="{ \
                                                '--paletteItemColor': neededColor.hash, \
                                                '--paletteItemBorderColor':  neededColor.hash === currentColor.hash ? 'black' : 'transparent' \
                                                }"
                                            @click="setCurrentColor(neededColor)"
                                            )
                .play-box__end-container(v-if='gameFinished && !isOlympiad && !showUnselectedGameItems')
                    fireworks(
                        v-if="gameFinished && !isOlympiad && gameResult === 'success' "
                        :is-mobile="isMobile"
                    )
                    .play-box__reaction-container
                        .play-box__answers-container
                            .play-box__answers.play-box__answers--left
                                | {{ $i18n.t('trainer.trainer_game_wordField_yourTime') }}
                                br
                                | {{ getTime }}
                            .play-box__answers.play-box__answers--right
                                | {{ $i18n.t('trainer.trainer_game_wordField_foundElements') }}
                                br
                                | {{ amountOfRightAnswers }} / {{ amountOfPossibleRightAnswers }}
                        .play-box__answers.play-box__answers--left.play-box__answers--show-md
                            | {{ $i18n.t('trainer.trainer_game_wordField_yourTime') }}
                            br
                            | {{ getTime }}
                        result-image.play-box__image(:status="gameResult")
                        .play-box__answers.play-box__answers--right.play-box__answers--show-md
                            | {{ $i18n.t('trainer.trainer_game_wordField_foundElements') }}
                            br
                            | {{ amountOfRightAnswers }} / {{ amountOfPossibleRightAnswers }}
                    result-buttons(
                        :exercise-id="exerciseId"
                        :game-name="type"
                        :games-type="parameters.courseType"
                        :show-restart-button="true"
                        @restartGame="restartGame"
                    )
                        slot
        cs-loader(v-else)
</template>

<script>
    /*eslint-disable*/
    import _, {cloneDeep} from 'lodash';
    import ScalingBar from './ScalingBar.vue';
    import textScrollMixin from '../../../../utils/trainer/textScroll';
    import playBoxGameMixin from '../../../../utils/trainer/playBoxGameMixin.js';
    import olympiadAnswerTimerMixin from '../../../../utils/olympiads/olympiadAnswerTimerMixin.js';
    import CorrectiveSamplesApi from "@/api/games/correctiveSamplesApi";
    import handsUpItems from "@/components/games/bonus-games/hands-up/HandsUpItems";

    const PERCENT_OF_NEEDED_ANSWERS = 0.8

    const CALCULATIONS_FONT_SIZE = 20;
    const CALCULATIONS_SIZE = 66;

    const DIGITS = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
    const ENGLISH_LETTERS =  ['a','b','c','d','e','f','g','h','i','j','k','l','m','n','o','p','q','r','s','t','u','v','w','x','y','z'];
    const ENGLISH_LETTERS_BIG =  ['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z'];
    const RUSSIAN_LETTERS = ['а', 'б', 'в', 'г', 'д', 'е', 'ё', 'ж', 'з', 'и', 'й', 'к', 'л', 'м', 'н', 'о', 'п', 'р', 'с', 'т', 'у', 'ф', 'х', 'ц', 'ч', 'ш', 'щ', 'э', 'ю', 'я'];
    const RUSSIAN_LETTERS_BIG = ['А', 'Б', 'В', 'Г', 'Д', 'Е', 'Ё', 'Ж', 'З', 'И', 'Й', 'К', 'Л', 'М', 'Н', 'О', 'П', 'Р', 'С', 'Т', 'У', 'Ф', 'Х', 'Ц', 'Ч', 'Ш', 'Щ', 'Э', 'Ю', 'Я'];
    const LOCALE_FOR_RUSSIAN_LETTERS = ['fr', 'lv', 'en'];
    const COLORS = [
        {name: 'green', hash: '#00F622FF'},
        {name: 'red', hash: '#ff0202'},
        {name: 'blue', hash: '#155ed5'},
        {name: 'gray', hash: '#747577'},
        {name: 'purple', hash: '#8413bb'},
        {name: 'yellow', hash: '#e9e900'},
    ]

    const THEMES_WITH_IMAGES = [
        'computationalSetBlack',
        'computationalSetColored',
        'arrows',
        'ringsOfLandolt',
        'halfPoints',
        'abcOfSanskrit',
        'symbol',
        'childrensSet',
        'pictograms',
    ];

    function DEFAULT_DATA () {
        return {
            isCurrentColorSeted: false,
            currentColor: {name: '', hash: ''},
            showNeededGameItems: true,
            showUnselectedGameItems: false,
            fontSize: CALCULATIONS_FONT_SIZE,
            widthForImages: CALCULATIONS_SIZE,
            heightForImages: CALCULATIONS_SIZE,
            amountOfGameItemsInRow: 1,
            gameResult: "success",
            clientWidth: 0,
            arrayOfUniqueObjects: [],
            arrayOfAllGameItems: [],
            amountOfRightAnswers: 0,
            amountOfSelectedGameItems: 0,
            heightForPlayBox: null,
        }
    }

    export default {
        mixins: [textScrollMixin, playBoxGameMixin, olympiadAnswerTimerMixin],
        created () {
            window.addEventListener('resize', this.getClientWidth);
            window.addEventListener('resize', this.calcHeightForPlayBox);
            window.addEventListener('resize', this.calculateAmountOfGameItemsInRow);
        },
        mounted () {
            this.gameBoxName = 'play-box__field';
            this.clientWidth = document.documentElement.clientWidth;
            this.fontSize = this.isImages ? CALCULATIONS_SIZE : CALCULATIONS_FONT_SIZE;
            if (this.clientWidth >= 320 && this.clientWidth <= 768 && this.isImages) {
                this.fontSize = 40
            }
        },
        watch: {
            time(val) {
                if (this.parameters.showTime && val >= this.parameters.showTime * 60) {
                    this.processReply();
                }
            },
        },
        data () {
            return DEFAULT_DATA();
        },
        computed: {
            displayedLines() {
                  return _.chunk(this.arrayOfAllGameItems, this.amountOfGameItemsInRow)
            },
            neededGameItems() {
                let array = this.arrayOfUniqueObjects.map((item) => ({...item}));
                array = _.shuffle(this.arrayOfUniqueObjects).slice(0, this.parameters.amountOfItems);
                array.forEach((neededItem, i) => {
                    neededItem.color = COLORS[i];
                })
                return array;
            },
            totalAmountOfItems() {
                return this.amountOfGameItemsInRow * this.parameters.amountOfRows;
            },
            gameItemsStyle () {
                if (!this.isImages) {
                    return {
                        'font-size': +this.fontSize + 'px',
                        'line-height': (+this.fontSize + 8) + 'px',
                        'padding': '6px'
                    }
                } else {
                    return {
                        'width': +this.widthForImages + 'px',
                        'height': +this.heightForImages + 'px'
                    }
                }
            },
            isImages () {
                return this.parameters && THEMES_WITH_IMAGES.includes(this.parameters.selectedTheme.theme);
            },
            neededColors() {
                return COLORS.slice(0, this.parameters.amountOfItems);
            },
            neededPencils() {
                const pencils = COLORS.slice(0, this.parameters.amountOfItems);
                return pencils.map(({name}) => name);
            },
            amountOfPossibleRightAnswers() {
                return Math.ceil(this.totalAmountOfItems * PERCENT_OF_NEEDED_ANSWERS);
            },
            lettersOrSyllables() {
                if (this.parameters.selectedTheme.theme === 'letters' || this.parameters.selectedTheme.theme === 'syllables') {
                    if (this.user.locale in handsUpItems[this.parameters.selectedTheme.theme]) {
                        return handsUpItems[this.parameters.selectedTheme.theme][this.user.locale];
                    } else {
                        return handsUpItems[this.parameters.selectedTheme.theme].en;
                    }
                } else {
                    return [];
                }
            },
            englishOrRussianLetters() {
                if (this.parameters.selectedTheme.theme === 'englishLettersBig') {
                    if (LOCALE_FOR_RUSSIAN_LETTERS.includes(this.user.locale)) {
                        return RUSSIAN_LETTERS_BIG;
                    } else {
                        return ENGLISH_LETTERS_BIG;
                    }
                }
                if (this.parameters.selectedTheme.theme === 'englishLetters') {
                    if (LOCALE_FOR_RUSSIAN_LETTERS.includes(this.user.locale)) {
                        return RUSSIAN_LETTERS;
                    } else {
                        return ENGLISH_LETTERS;
                    }
                }
            },
        },
        methods: {
            getClientWidth() {
                this.clientWidth = document.documentElement.clientWidth;
                if (this.clientWidth < 576 && this.fontSize > 30) {
                    this.setFontSize(30);
                } else if (this.clientWidth < 766 && this.fontSize > 40) {
                    this.setFontSize(40);
                } else if (this.clientWidth < 1200 && this.fontSize > 60) {
                    this.setFontSize(60);
                } else if (this.clientWidth < 1430 && this.fontSize > 80) {
                    this.setFontSize(80);
                } else if (this.clientWidth < 1920 && this.fontSize > 100) {
                    this.setFontSize(100);
                } else if (this.clientWidth >= 1920){
                    this.setFontSize(150);
                }
            },
            calcHeightForPlayBox () {
                const clientWidth = document.documentElement.clientWidth;
                const clientHeight = document.documentElement.clientHeight;
                let value = '350px';

                if (clientWidth < clientHeight) {
                    if (clientWidth >= 540 && clientWidth < 768) {
                        value = `calc(100vh - 600px)`
                    }
                    if (clientWidth >= 768) {
                        value = 'calc(100vh - 700px)'
                    }
                } else {
                    if (clientWidth >= 1680) {
                        value = `calc(100vh - 600px)`
                    }
                }

                this.heightForPlayBox = value
            },
            registerSounds() {
                this.$createjs.Sound.removeAllSounds();
                this.$createjs.Sound.removeAllEventListeners();
                this.$createjs.Sound.alternateExtensions = ['mp3', 'ogg'];
                this.$createjs.Sound.registerSounds(this.soundObjects);
            },
            async fetchData() {
                try {
                    await this.getExercise();
                    this.calculateAmountOfGameItemsInRow();
                    await this.fillGameItems();
                    this.createArrayOfAllGameItems();
                    this.registerSounds();
                    this.startGame();
                    this.calcHeightForPlayBox();
                } catch (e) {
                    this.showErrorMessage(e);
                }
            },
            calculateAmountOfGameItemsInRow() {
                this.clientWidth = document.documentElement.clientWidth;
                let computedWidthImprecision = 150;
                if (this.clientWidth > 768 ) computedWidthImprecision = 200;
                if (this.clientWidth > 991) computedWidthImprecision = 250;
                if (this.clientWidth > 1200) computedWidthImprecision = 360;
                if (this.isImages) {
                    const gameContainerWidth = document.querySelector(".play-box").clientWidth - computedWidthImprecision;
                    this.amountOfGameItemsInRow = Math.floor(gameContainerWidth / 65);
                } else {
                    const gameContainerWidth = document.querySelector(".play-box").clientWidth - 140;
                    let widthCoefficient = 14;
                    if (this.parameters.selectedTheme.theme === 'syllables') widthCoefficient = 18
                    this.amountOfGameItemsInRow = Math.floor((gameContainerWidth / widthCoefficient) / 3);
                }
            },
            setCurrentColor(color) {
                  this.currentColor = color;
            },
            async fillGameItems() {
                if (this.parameters.selectedTheme.theme === 'digits') {
                    this.createThemesArray(DIGITS);
                }
                if (this.parameters.selectedTheme.theme === 'englishLettersBig') {
                    this.createThemesArray(this.englishOrRussianLetters);
                }
                if (this.parameters.selectedTheme.theme === 'englishLetters') {
                    this.createThemesArray(this.englishOrRussianLetters);
                }
                if (this.parameters.selectedTheme.theme === 'letters') {
                    this.createThemesArray(this.lettersOrSyllables);
                }
                if (this.parameters.selectedTheme.theme === 'syllables') {
                    this.createThemesArray(this.lettersOrSyllables);
                }
                if(THEMES_WITH_IMAGES.includes(this.parameters.selectedTheme.theme)) {
                    const { items } = await this.getGameItems(this.parameters.selectedTheme.theme);
                    this.createThemesArray(items);
                }
            },
            getGameItems(theme) {
                return CorrectiveSamplesApi.getGameItems({theme, count: this.totalAmountOfItems});
            },
            createThemesArray(items) {
                this.arrayOfUniqueObjects = items.map(elem => ({value:elem, color: null}))
            },
            refreshGameStatBeforeSend () {
                this.gameStat.answers = this.amountOfRightAnswers;
                this.gameStat.attempts = 1;
                this.gameStat.isCompleted = this.gameFinished;
                this.gameStat.executionTime = this.time;
                this.gameStat.isCorrect = true;
                this.gameStat.percent = parseInt((this.amountOfRightAnswers / this.amountOfPossibleRightAnswers) * 100);
                this.gameStat.amountOfPossibleRightAnswers = this.amountOfPossibleRightAnswers;
                this.gameStat.allGameItems = this.totalAmountOfItems;
                this.gameStat.amountOfRightAnswers = this.amountOfRightAnswers;
                this.gameStat.parameters = _.cloneDeep(this.parameters);
            },
            beforeStart () {
                this.startGame();
            },
            startGame () {
                this.gameStarted = true;
                if (this.answerDuration) {
                    this.startAnswerTimer();
                }
                if (this.parameters.withTime) {
                    setTimeout(() => {
                        this.showNeededGameItems = false;
                        this.startTimer();
                    }, this.parameters.showTime * 1000)
                } else {
                    this.startTimer();
                }
            },
            startTimer () {
                this.$nextTick(() => {
                    if (!this.timer) {
                        this.setTimer();
                    }
                });
            },
            createArrayOfAllGameItems () {
                let preResArray = [];
                for (let i = 0; i < this.amountOfPossibleRightAnswers; i++) {
                    preResArray.push(this.neededGameItems[this.getRandomInt(0, this.neededGameItems.length)])
                }
                const neededGameItemsSetValues = new Set(this.neededGameItems.map(({value}) => value));
                const notNeededItems = this.arrayOfUniqueObjects.filter(({value}) => !neededGameItemsSetValues.has(value));
                for (let i = 0; i < this.totalAmountOfItems - this.amountOfPossibleRightAnswers; i++) {
                    preResArray.push(notNeededItems[this.getRandomInt(0, notNeededItems.length)])
                }

                this.arrayOfAllGameItems = _.shuffle(preResArray).map(item => ({...item, selectedColor: null, invalid: false}));
            },
            getRandomInt (min, max) {
                return Math.floor(Math.random() * (max - min)) + min;
            },
            selectWord (gameItem) {
                if (!this.currentColor.name) {
                    return;
                }
                if (this.amountOfSelectedGameItems >= this.amountOfPossibleRightAnswers && !gameItem.selectedColor) {
                    return
                }
                if (gameItem.selectedColor === this.currentColor) {
                    gameItem.selectedColor = null;
                    this.amountOfSelectedGameItems--;
                } else {
                    if (!gameItem.selectedColor) {
                        this.amountOfSelectedGameItems++;
                    }
                    gameItem.selectedColor = this.currentColor;
                }
            },
            processReply () {
                this.stopTimer();
                const map = new Map(this.neededGameItems.map(({color, value}) => [value, color]));
                this.arrayOfAllGameItems.forEach((gameItem) => {
                    if (map.has(gameItem.value)) {
                        if (map.get(gameItem.value) !== gameItem.selectedColor)  {
                            gameItem.invalid = true;
                        }
                    } else if (gameItem.selectedColor){
                            gameItem.invalid = true;
                    }
                    if (gameItem.selectedColor && !gameItem.invalid) {
                        this.amountOfRightAnswers++
                    }
                });
                if (this.amountOfRightAnswers < Math.ceil(this.amountOfPossibleRightAnswers/2)) {
                    this.gameResult = "failure";
                }
                if (this.amountOfRightAnswers < this.amountOfPossibleRightAnswers) {
                    this.showUnselectedGameItems = true;
                }
                this.gameFinished = true;
                this.sendStat();
            },
            setFontSize (fontSize) {
                if (this.isImages) {
                    this.widthForImages = fontSize;
                    this.heightForImages = fontSize;
                }
                this.fontSize = fontSize;
            },
            beforeGameRestart () {
                Object.assign(this, DEFAULT_DATA());
            },
            wordClass (gameItem) {
                return {
                        [`play-box__word--selected_${gameItem.selectedColor?.name}`]: !!gameItem.selectedColor && !gameItem.invalid,
                        'play-box__word--incorrect': gameItem.invalid
                    }
            }
        },
        destroyed() {
            window.removeEventListener('resize', this.getClientWidth);
            window.removeEventListener('resize', this.calcHeightForPlayBox);
            window.removeEventListener('resize', this.calculateAmountOfGameItemsInRow);
        },
        components: {
            ScalingBar,
        },
    }
</script>

<style lang="scss" scoped>
    @import "@/assets/sass/games/playbox.scss";

    .mobile-version {
        flex-direction: column;
        align-items: center;
        text-align: center;
    }

    .play-box--warning {
        display: table;
    }

    .play-box__game {
        display: flex;
        flex: 1 1 auto;
        flex-direction: column-reverse;
        @include media($lg) {
            flex-direction: row;
        }
    }

    .play-box__example {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        flex-grow: 5;
        flex-direction: column;
    }

    .play-box__container {
        display: flex;
    }

    .play-box__field {
        padding: 0 20px;
        text-align: center;
        font-size: 18px;
        user-select: none;
        flex-wrap: wrap;
        justify-content: center;
        overflow-y: auto;
        @include scrollbar;
    }

    .play-box__words-row {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
    }

    .play-box__answer-container {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .answer-container__header {
        margin-bottom: 20px;
        font-weight: 500;
        font-size: 32px;
        line-height: 38px;
    }

    .answer-container__input .cs-input {
        margin-bottom: 0;
        font-size: 52px;
        line-height: 62px;
        padding: 9px 15px;
        text-align: center;
        max-width: 330px;
    }

    .play-box__word {
        margin: 0 10px 3px 0;
        cursor: pointer;
        border: 3px solid transparent;
        box-sizing: border-box;
    }

    .play-box__word:last-child {
        margin-right: 0;
    }

    .play-box__word--selected {
        &_yellow {
            border: 3px solid #e9e900;
        }
        &_green {
            border: 3px solid #00F622FF;
        }
        &_purple {
            border: 3px solid #8413bb;
        }
        &_red {
            border: 3px solid #ff0202;
        }
        &_gray {
            border: 3px solid #747577;
        }
        &_blue {
            border: 3px solid #155ed5;
        }
    }

    .play-box__word--incorrect {
        background-color: red;
    }

    .play-box__word--inverted {
        display: inline-block;
        transform: rotate(180deg);
        margin-right: 10px;
    }

    .play-box__header {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        font-weight: 500;
        font-size: 28px;
        line-height: 34px;
        margin-bottom: 20px;
    }

    .play-box__before-start-game-header {
        flex-direction: column;
    }

    .play-box__task {
        align-self: flex-start;
    }

    .play-box__title {
        margin-bottom: 20px;
        text-align: center;
    }

    .play-box__scaling-bar-block {
        margin-left: 20px;
        @include media($xlg) {
            margin-left: 40px;
        }
    }

    .play-box__subtitle {
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 0;
        justify-content: center;
    }

    .palette-item {
        width: 40px;
        height: 40px;
        margin: 10px;
        background-color: var(--paletteItemColor);
        border: 2px solid var(--paletteItemBorderColor);
    }

    .play-box__end-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
    }

    .play-box__reaction-container {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: row;
        width: 100%;
    }

    .play-box__answers {
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        text-align: center;
        @include media($lg) {
            font-size: 32px;
            line-height: 38px;
        }
        @include media($xl) {
            font-size: 42px;
            line-height: 50px;
        }
    }

    .play-box__answers--left {
        color: $hsl-color-green-58;
        margin-left: 20px;
        @include media($lg) {
            margin-left: 35px;
        }
    }

    .play-box__answers--right {
        color: $hsl-color-green-58;
        margin-right: 20px;
        @include media($lg) {
            margin-right: 35px;
        }
    }

    .play-box__answers--show-md {
        display: block;
    }

    .play-box__answers-container {
        display: none;
    }

    .play-box__image {
        max-width: 100%;
        margin-bottom: 40px;
        @media screen and (max-width: 1200px){
            height: 400px;
        }
    }

    .play-box__buttons {
        display: flex;
        flex-direction: column;
        margin-top: 25px;
        @include media($lg) {
            flex-direction: row;
        }
    }

    .play-box__buttons--game {
        margin: 0 0 25px;
        justify-content: center;
    }

    .play-box__button {
        margin: 20px 0;
        @include media($lg) {
            margin: 0 20px;
        }
    }

    .play-box__button:first-child {
        margin-top: 0;
        @include media($lg) {
            margin-left: 0;
        }
    }

    .play-box__button:last-child {
        margin-bottom: 0;
        @include media($lg) {
            margin-right: 0;
        }
    }

    .play-box__game-info {
        align-self: flex-end;
        @include media($lg) {
            align-self: auto;
        }
    }

    .warning {
        display: table-cell;
        vertical-align: middle;
        text-align: center;
    }
</style>
